export default {
  root: 'https://www.ncu.edu.jm/manage/wp-json/wp/v2/',
  rootUrl: 'https://cmsapi.ncu.edu.jm/project/ncuMain/',
  news_root: 'http://news.ncu.fm/manage/wp-json/wp/v2',
  strapiApi: 'http://cmsapi.ncu.edu.jm:1337/',
  monthTracker: {},
  d : new Date(),
  academicCalendar: {
    august_2018: [],
    september_2018: [],
    october_2018: [],
    november_2018: [],
    december_2018: [],
    january_2019: [],
    february_2019: [],
    march_2019: [],
    april_2019: [],
    may_2019: [],
    june_2019: [],
    july_2018: []
  },
  month : ['january_2019', 'february_2019', 'march_2019', 'april_2019', 'may_2019', 'june_2019', 'july_2018', 'august_2018', 'september_2018', 'october_2018', 'november_2018', 'december_2018'],
  days: [
    ['S','U','N'],
    ['M','O','N'],
    ['T','U','E'],
    ['W','E','D'],
    ['T','H','U'],
    ['F','R','I'],
    ['S','A','T'],
  ],
  dayIndex: 0,
  dayArray: {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6
  },
  upcomingEvent: {},
  upcomingEvents:[],
  UpcomingEventsList: [],
  UpcomingEvent: {},
  eventsCalendar: {
    august_2018: [],
    september_2018: [],
    october_2018: [],
    november_2018: [],
    december_2018: [],
    january_2019: [],
    february_2019: [],
    march_2019: [],
    april_2019: [],
    may_2019: [],
    june_2019: [],
    july_2018: []
  },
  newsArticleSlide: [],
  sportsArticleSlide: [],
  viewArticle: []
}
